import * as STD from '@emersya/mpa-std-lib';
import CM from '@emersya/mpa-components-manager-lib';

export interface IInputButtonComponentConfiguration extends IInputComponentConfiguration<
	STD.object.JSON,
	STD.object.JSON
> {
	disableClickPropagation?: boolean;
};

export class InputButtonComponent<
	TComponent extends InputButtonComponent<any, TConfiguration> = InputButtonComponent<InputButtonComponent<any, IInputButtonComponentConfiguration>, any>,
	TConfiguration extends IInputButtonComponentConfiguration = IInputButtonComponentConfiguration
> extends InputComponent<
	HTMLButtonElement,
	STD.object.JSON,
	STD.object.JSON,
	TComponent,
	TConfiguration
> {
	component_DOM: HTMLButtonElement;

	override deserialize(x: STD.object.JSON) {
		return (x);
	};

	override isValueTheDefault() {
		return (true);
	};

	async reset() {
		//NO-OP expected
	};

	private async onClick(ev: Event) {
		try {
			if (this.component_configuration.disableClickPropagation) {
				ev.stopPropagation();
				ev.stopImmediatePropagation();
			}
			await this.updateValue(this.value);
		} catch (error) {
			this.component_throwBoundUnknownError('Error during click handling!', {}, error);
		}
	};

	serialize() {
		return this.value;
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: TConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM = <HTMLButtonElement>STD.DOM.factory({
			tag: 'button',
			events: {
				click: this.onClick.bind(this)
			},
			classList: ['text-title-actionnable']
		});
		if (this.component_hasTranslation('text')) {
			this.component_DOM.appendChild(STD.DOM.factory({
				tag: 'p',
				attributes: {
					'data-translation': <string>this.component_getTranslationId('text')
				}
			}));
		} else if (this.component_configuration['@stringData']) {
			this.component_DOM.textContent = this.component_configuration['@stringData'];
		}
	};
};
export namespace NS {
	export const Component = InputButtonComponent;
	export type Component = InputButtonComponent;
	export type Configuration = IInputButtonComponentConfiguration;
}
import './InputButton.scss';
import {InputComponent, IInputComponentConfiguration} from '../Input/Input';

CM.declare({
	id: 'input-button',
	type: InputButtonComponent
});
